import { render } from "./SleepModal.vue?vue&type=template&id=51c73f54&scoped=true&ts=true"
import script from "./SleepModal.vue?vue&type=script&lang=ts"
export * from "./SleepModal.vue?vue&type=script&lang=ts"

import "./SleepModal.vue?vue&type=style&index=0&id=51c73f54&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c73f54"]])

export default __exports__